import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PageLoader = ({ message }) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '200px',
        width: '100%',
        gap: 2
      }}
    >
      <CircularProgress />
      <Typography color="textSecondary">
        {message || t('sidebar.loading')}
      </Typography>
    </Box>
  );
};

export default PageLoader;
